"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    field: { borderWidth: '1px' },
};
const baseVariantFieldStyle = {
    _invalid: {
        boxShadow: 'none',
    },
    _focus: {
        boxShadow: 'none',
    },
};
const size = {
    lg: {
        borderRadius: 'base',
        fontSize: 'md',
    },
    md: {
        borderRadius: 'base',
    },
};
const sizes = {
    lg: {
        field: size.lg,
        addon: size.lg,
    },
    md: {
        field: size.md,
        addon: size.md,
    },
};
const variants = {
    outline: {
        field: Object.assign({ borderColor: 'gray.400' }, baseVariantFieldStyle),
    },
    filled: {
        field: baseVariantFieldStyle,
    },
    flushed: {
        field: baseVariantFieldStyle,
    },
};
const InputStyle = {
    variants,
    baseStyle,
    sizes,
    defaultProps: {
        size: 'lg',
        errorBorderColor: 'red.400',
        focusBorderColor: 'notification.blue',
    },
};
exports.default = InputStyle;
